  document.addEventListener('click', function (e) {
    const link = e.target.closest('.video-text a');
    if (!link) return;

    e.preventDefault();

    const target = document.getElementById('video-sec');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  });
